import { useNotificationsQuery } from "@graphql/notifications/Notifications.g";
import { useNavigate } from "react-router";

import { routes } from "@pages/routes";

const DEFAULT_LIMIT = 8;

export const useRecentAlertsQuery = (
  clientId?: string,
  limit = DEFAULT_LIMIT,
) => {
  return useNotificationsQuery({
    clientId,
    resolvedAt_Isnull: true,
    sortBy: "-created_at",
    first: limit,
  });
};

export const useRecentAlerts = (clientId?: string, limit = DEFAULT_LIMIT) => {
  const navigate = useNavigate();
  const notificationsQuery = useRecentAlertsQuery(clientId, limit);
  const totalCount = notificationsQuery.data?.notifications?.totalCount ?? 0;
  const isLoading = notificationsQuery.isLoading;

  const seeAllPath = clientId
    ? routes.portal.clients.client.notifications.$buildPath({
        params: { clientId },
      })
    : routes.portal.notifications.$path();

  const handleSeeAll = () => {
    navigate(seeAllPath, { viewTransition: true });
  };

  return { totalCount, isLoading, handleSeeAll };
};
